"use client";
import { CDNRoutes, Routes } from "@/api";
import { HasUnreadNotificationsQuery } from "@/hooks/queries/user/use-has-unread-notifications-query";
import { useSession } from "next-auth/react";
import React from "react";

import useMeasure from "@/hooks/layout/use-measure";
import { cn } from "@/lib/utils";
import { useHeaderHeightStore } from "@/stores/height-store";
import { usePathname } from "next/navigation";

import { ChatRoomCallInfo } from "./chat/room/chat-room-call-info";
import MobileOnly from "./mobile-only";
import { SidebarTrigger } from "./ui/sidebar";

// const MIN_CENTER_LOGO_SCREEN_SIZE = 300;

// function useScreenSize() {
//   const [screenWidth, setScreenWidth] = React.useState(0);
//   const [screenHeight, setScreenHeight] = React.useState(0);

//   React.useEffect(() => {
//     setScreenWidth(window.innerWidth);
//     setScreenHeight(window.innerHeight);

//     const handleResize = () => {
//       setScreenWidth(window.innerWidth);
//       setScreenHeight(window.innerHeight);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   return {
//     width: screenWidth,
//     height: screenHeight,
//   };
// }

interface Props {
  readonly className?: string;
}

export function MainHeader(props: Props) {
  const pathname = usePathname() ?? "N/A";
  const isHome = pathname.includes(Routes.HOME);
  // const isPortfolioRoute = pathname.includes("portfolio");

  // const authDialogContext = useAuthDialogContext();
  // const showAuthDialog = () => {
  //   authDialogContext.onOpenChange(true);
  // };
  const hasUnreadNotificationsQuery = HasUnreadNotificationsQuery.useQuery();

  const hasUnreadNotifications =
    hasUnreadNotificationsQuery.data?.hasUnread ?? false;

  const { status } = useSession();
  const [ref, measure] = useMeasure<HTMLElement>();
  const isLoggedIn = status === "authenticated";

  React.useEffect(() => {
    const favicon = document.querySelector(
      "link[rel*='icon']",
    ) as HTMLLinkElement;

    if (!favicon) {
      return;
    }

    if (hasUnreadNotifications) {
      favicon.href = CDNRoutes.public("favicon-unread.ico");
    } else {
      favicon.href = `/favicon.ico`;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasUnreadNotificationsQuery.data?.hasUnread]);

  React.useEffect(() => {
    useHeaderHeightStore.setState({ height: measure.height });
  }, [measure.height]);

  if (!isLoggedIn) {
    return;
  }

  return (
    <MobileOnly>
      <nav
        ref={ref}
        className={cn(
          "fixed bottom-4 left-[15%] z-10 m-0 flex -translate-x-[50%] flex-col items-center",
          props.className,
          isHome && !isLoggedIn ? "hidden" : "h-12",
        )}
      >
        <div className="flex h-12 min-w-12 items-center justify-center rounded-full border bg-primary text-primary-foreground md:hidden">
          <SidebarTrigger />
          <ChatRoomCallInfo className="flex-row items-center justify-center gap-2" />
        </div>
      </nav>
    </MobileOnly>
  );
}

// function Banner() {
//   return null;
// return (
//   <div className="flex flex-col items-center justify-center border-t bg-secondary px-4 py-2 text-sm font-medium md:flex-row">
//     <p className="text-center text-foreground">{headerBanner.text}&nbsp;</p>
//     <a href={headerBanner.link.href}>
//       <p className="font-bold text-foreground">{headerBanner.link.text}</p>
//     </a>
//   </div>
// );
// }
// export function CtaBanner(props: { onClick: VoidFn }) {
//   const searchParams = useSearchParams();
//   if (!searchParams?.get(Cookies.affiliate)) {
//     return null;
//   }

//   return (
//     <div className="flex w-full flex-col items-center justify-center border-t bg-secondary py-1 text-sm font-medium md:flex-row">
//       <p className="text-center text-foreground">{ctaBanner.text}&nbsp;</p>
//       {"link" in ctaBanner ? (
//         <a href={ctaBanner.link.href}>
//           <p className="font-bold text-foreground underline underline-offset-4">
//             {ctaBanner.link.text}
//           </p>
//         </a>
//       ) : (
//         <Button
//           variant={"ghost"}
//           size={"sm"}
//           onClick={props.onClick}
//           className="font-bold text-foreground underline underline-offset-4"
//         >
//           {ctaBanner.ctaText}
//         </Button>
//       )}
//     </div>
//   );
// }
